module.exports = __webpack_public_path__ + "img/logo.f5f88843.svg";